import { Unauthorized } from 'app/cross-cutting-concerns/authentication/components/Unauthorized/Unauthorized';

export const UnauthorizedPage = (): JSX.Element => <Unauthorized />;
